<template>
  <b-modal v-model="modalVisible" centered hide-footer title="變更狀態">
    <template #default>
      <div>
        <b-form-group
          label="要變更的狀態"
        >
          <b-form-select class="w-100" v-model="selectedStatus" :options="statusOpts"></b-form-select>
        </b-form-group>
      </div>

      <div v-if="selectedStatus === 1">
        <b-form-group
          label="借用客戶"
        >
          <b-form-select class="w-100" v-model="selectedClient" :options="clientOpts"></b-form-select>
        </b-form-group>
      </div>

      <div>
        <b-button class="w-100" variant="primary" @click="statusSaveBtnClicked">
          儲存變更
        </b-button>
      </div>

    </template>
  </b-modal>
</template>

<script>
import commonBusyAndErrorHandling from "@/assets/js/commonBusyAndErrorHandling";
import {mapState} from "vuex";
export default {
  mixins: [commonBusyAndErrorHandling],
  name: 'KegStatusChangeModal',
  data() {
    return {
      selectedStatus: 0,
      selectedClient: -1,

      statusOpts: [
        {
          text: '在庫',
          value: 0,
        },
        {
          text: '出借',
          value: 1,
        },
        {
          text: '失蹤',
          value: 2,
        },
        {
          text: '退役',
          value: 3,
        },
      ],
    };
  },
  components: {
  },
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false,
      passed: false,
    },
    keg: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState('client', ['clientList']),
    modalVisible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    clientOpts() {
      return this.clientList.map((item) => {
        return {
          text: `${item.name}(${item.salesman})`,
          value: item.serial
        }
      });
    },
    

  },
  watch: {
    
  },
  mounted() {
  },
  methods: {
    async statusSaveBtnClicked() {
      try {
        switch(this.selectedStatus) {
          case 0:
            await this.handleAsyncTask(() => this.$store.dispatch('keg/kegStock', {kegSerial: this.keg.serial}));
            break;
          case 1:
            await this.handleAsyncTask(() => this.$store.dispatch('keg/kegRent', {kegSerial: this.keg.serial, clientSerial: this.selectedClient}));
            break;
          case 2:
            await this.handleAsyncTask(() => this.$store.dispatch('keg/kegMissing', {kegSerial: this.keg.serial}));
            break;
          case 3:
            await this.handleAsyncTask(() => this.$store.dispatch('keg/kegRetired', {kegSerial: this.keg.serial}));
            break;
        }
        this.modalVisible = false;
        await this.$bvModal.msgBoxOk('狀態已儲存!');
      } catch (error) {
        console.error(error);
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/basic";

</style>
